(function($) {
    $(() => {
        const slider = $('.process-slider');

        slider.on('init reInit', function(event, slick) {
            $('.process-slider__total-count').html(`1/${slick.slideCount}`);
        });

        slider.on('afterChange', function (event, slick, currentSlide) {
            $('.process-slider__count').html(currentSlide + 1);
            $('.process-slider__total-count').html(`${currentSlide + 1}/${slick.slideCount}`);

            // const icons = $('.process-slider__icon-wrapper');
            // icons.filter(function () {
            //     return parseInt($(this).data('step')) > currentSlide;
            // }).removeClass('active');

            // icons.removeClass('active');

            // icons.filter(function () {
            //     return parseInt($(this).data('step')) <= currentSlide;
            // }).addClass('active');
            $('.process-slider__icon-wrapper').removeClass('active');
            $(`.process-slider__icon-wrapper[data-step="${currentSlide}"]`).addClass('active');
        });

        slider.slick(
            {
                infinite: true,
                slidesToShow: 1,
                arrows: true,
                nextArrow:  $('.process-slider__right'),
                prevArrow:  $('.process-slider__left'),
            }
        );

        $('.process-slider__icon-wrapper').on('click', function () {
            slider.slick('slickGoTo', $(this).data('step'));
            // $('.process-slider__icon-wrapper').removeClass('active');
            // $(this).addClass('active');
        })
    });
})(jQuery);